var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from "redux-act";
import { slidePage, initSurvaySuccess } from "./actions";
var defaultState = {
    page: 1,
    survays: []
};
var survayReducer = createReducer({}, defaultState).on(slidePage, function (state, payload) {
    return __assign(__assign({}, state), { page: payload > 6 ? 6 : payload < 1 ? 1 : payload });
}).on(initSurvaySuccess, function (state, payload) {
    return __assign(__assign({}, state), { survays: payload.questions, page: payload.pageNum });
});
var SurvayReducer = ({
    survay: survayReducer
});
export default SurvayReducer;



//////////////////
// WEBPACK FOOTER
// ./src/pages/Survay/ducks/index.ts
// module id = 687
// module chunks = 0